<template>
  <div class="spring-text" ref="animationTitle" v-intersect="{ callback: handleIntersect, threshold: 1 }">
    {{text}}
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    split: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
   
    };
  },
  computed: {},
  mounted() {
    
  },
  watch: {
   
  },
  methods: {
    handleIntersect(entry, observer) {
      if (this.split)
       this.animateSplitText();
      else 
        this.animateText();
      observer.unobserve(entry.target);
    },
    animateText() {
      const texts = this.$refs.animationTitle;
      texts.classList.add("jump-animation");
    },
    animateSplitText() {
      const texts = this.$refs.animationTitle;
      texts.style.setProperty("--opacity", 1);
      const textResult = texts.textContent.trim().split("").map((c) => `<span class=${c == ' ' ? 'none-text' : ''}>${c == ' ' ? '\u00A0' : c}</span>`).join("");
      texts.innerHTML = textResult;
      const spans = texts.childNodes;
      for (let i = 0; i < spans.length; i++) {
        spans[i].style.setProperty("--delay", `${i * 0.02}s`);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
